import React from "react"
import Layout from "../components/layout/layout"
import SEO from "../components/layout/seo"
import {StaticImage} from "gatsby-plugin-image"
import Figure from "../components/figure"

export default function Ddom() {
    const seo = {
        title: "Adaptacja wysokiego parteru budynku POZ i AOS w NZOZ MEDICUS DUKLA w Dukli do wymagań Standardu Dostępności POZ - Przychodnia specjalistyczna Medicus-Dukla",
        url: "https://medicusdukla.pl/adaptacja-wysokiego-parteru"
    }
    return (
        <Layout marginTop={'8rem'}>
            <SEO
                title={seo.title}
                description={seo.description}
                url={seo.url}
            />
            <div data-g="container" className="u-text-center">
                <div className="projects-logos">
                    <StaticImage className="a-img" src="../images/adaptacja-wysokiego-parteru/finansowanie.jpg"
                                 alt="fundusze europejskie, rzeczpospolita polska, podkarpackie, unia europejska"
                                 formats={['auto', 'webp', 'avif']}/>

                </div>
                <br/>
                <br/>
            </div>
            <section className="o-ddom"  style={{maxWidth: '600px', width: '100%', margin: '0 auto'}}>
                    <h1 className="a-heading-medium">Adaptacja wysokiego parteru budynku POZ i AOS w NZOZ MEDICUS DUKLA w Dukli do wymagań Standardu Dostępności POZ</h1>
                    <p>FEPK.05 Przyjazna Przestrzeń
                      Społeczna” z programu regionalnego Fundusze Europejskie dla Podkarpacia 2021-2027</p>
                  <h2 className="a-heading-small">Zadania realizowane w projekcie:</h2>
                    <ul className="o-ddom__list">
                        <li>Prace remontowo-budowlane adaptujące wysoki parter Przychodni do wymagań standardu dostępności POZ opisane w Kosztorysie inwestorskim</li>
                        <li>Modernizacja strony internetowej</li>
                        <li>Instalacja Systemu Kolejkowego</li>
                        <li>Instalacja Systemu Przywoławczego</li>
                    </ul>

                  <h2 className="a-heading-small">Szczegóły projektu:</h2>
                  <ul className="o-ddom__list">
                        <li>Projekt skierowany jest do osób niepełnosprawnych, osób starszych powyżej 60 roku życia</li>
                        <li>Cele projektu: poprawa dostępności architektonicznej, zniesienie barier dostępu</li>
                        <li>Całkowity koszt projektu: <strong>2&nbsp;327&nbsp;151,03 PLN</strong></li>
                        <li>Wysokość wkładu z Funduszy Europejskich: <strong>1&nbsp;904&nbsp;893,37 PLN</strong></li>
                        <li>Rezultaty projektu to świadczenie usług medycznych bez barier dla osób z
                      niepełnosprawnościami</li>
                    </ul>
            </section>
        </Layout>
    )
}
